module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "qatar_event2.7bc86066.png";